import { render, staticRenderFns } from "./ListPlaylist.vue?vue&type=template&id=ffc87c8c&scoped=true&"
import script from "./ListPlaylist.vue?vue&type=script&lang=js&"
export * from "./ListPlaylist.vue?vue&type=script&lang=js&"
import style0 from "./ListPlaylist.vue?vue&type=style&index=0&id=ffc87c8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc87c8c",
  null
  
)

export default component.exports